import { useTranslation } from 'react-i18next';
import { showToast } from '../../utils/toast';
import { useTransactionTypeList } from '../../../hooks/useTransactionTypeList';

type TransactionTypeList = ReturnType<typeof useTransactionTypeList>;

type ClearableFilters = Pick<
  TransactionTypeList,
  | 'selectedCategoryFilters'
  | 'isMatterTransactionTypesFilterActive'
  | 'isInternalMatter'
  | 'resetFilterToDefault'
  | 'resetFilterToMatterType'
  | 'removeCategoryFilter'
  | 'clearCategoryFilters'
>;

/**
 * Removing one tag, or clearing them all, the way the transaction type picker page does it, so
 * every surface listing transaction types behaves alike.
 */
export const useClearTransactionTypeFilter = ({
  selectedCategoryFilters,
  isMatterTransactionTypesFilterActive,
  isInternalMatter,
  resetFilterToDefault,
  resetFilterToMatterType,
  removeCategoryFilter,
  clearCategoryFilters,
}: ClearableFilters) => {
  const { t } = useTranslation();

  const resetRadioFilter = () => {
    if (isMatterTransactionTypesFilterActive) {
      resetFilterToMatterType();
      showToast(
        'info',
        isInternalMatter
          ? t('transaction:transactionType.filter.internalAppliedAfterClear')
          : t('transaction:transactionType.filter.billableAppliedAfterClear'),
        { autoClose: false },
      );
      return;
    }
    resetFilterToDefault();
  };

  return (value?: string) => {
    if (value && selectedCategoryFilters.some((option) => option.value === value)) {
      removeCategoryFilter(value);
      return;
    }
    if (!value) {
      clearCategoryFilters();
    }
    resetRadioFilter();
  };
};
